import { useEffect, useRef } from 'react';

/**
 * An isolated rich-text input. React owns the block shell only; the browser
 * owns its editable HTML while the document state is synchronized on input.
 */
export default function TextBlock({ blockKey, content, editable, onChange, onBlur, onPaste }) {
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element || document.activeElement === element || element.innerHTML === content) return;
    element.innerHTML = content;
  }, [content]);

  return (
    <div
      ref={elementRef}
      className="board-text-body__text-block"
      data-content-block={blockKey}
      contentEditable={editable}
      suppressContentEditableWarning
      onBlur={event => onBlur(event.currentTarget.innerHTML)}
      onInput={event => onChange(event.currentTarget.innerHTML)}
      onPaste={onPaste}
    />
  );
}
